import React from 'react';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import ConflictView from './ConflictView';
import PaymentView from './PaymentView';
import usePayment from './usePayment';

const styles = {
  divLoading: {
    height: 880,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const PaymentDialog = ({ data, artisan, user, users, onSave }) => {
  const payment = usePayment(data, artisan, onSave);

  if (payment.visible) {
    return (
      <div style={styles.divLoading}>
        <CircularProgress size={100} />
        <Typography variant="h6" children="Chargement en cours..." />
      </div>
    );
  }

  if (payment.openSecDialog) {
    return (
      <ConflictView
        onCancel={payment.onReject}
        changeMethods={payment.changeMethods}
      />
    );
  }

  return (
    <PaymentView
      data={payment.data}
      artisan={payment.artisan}
      save={payment.save}
      loading={payment.loading}
      visible={payment.visible}
      statusRemuneration={payment.statusRemuneration}
      user={user}
      users={users}
      onReject={payment.onReject}
      onValidate={payment.onValidate}
      finishLoading={payment.finishLoading}
      sendPayement={payment.sendPayement}
      setRem={payment.setRem}
      setInter={payment.setInter}
      setComments={payment.setComments}
    />
  );
};

const mapStateToProps = ({
  connectedUser,
  users,
  dialog: { contentProps: { data, artisan, onSave } = {} },
}) => ({
  user: connectedUser,
  users,
  data,
  artisan,
  onSave,
});

export default connect(mapStateToProps)(PaymentDialog);
